import { Moon, Check } from "lucide-react";

// Stylized, realistic-looking MAX messenger conversation with the bot.
export const BotChat = ({ chat, testId }) => {
  return (
    <div
      className="flex h-full w-[300px] flex-none flex-col overflow-hidden rounded-[26px] border border-[#D4AF6E]/25 bg-[#0e0e26] shadow-[0_20px_60px_-20px_rgba(91,58,120,0.6)] sm:w-[320px]"
      data-testid={testId}
    >
      {/* Chat header */}
      <div className="flex items-center gap-3 border-b border-[#D4AF6E]/12 bg-[#111133] px-4 py-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-full gold-gradient">
          <Moon className="h-5 w-5 text-[#0B0B1F]" />
        </span>
        <div className="leading-tight">
          <p className="text-sm font-semibold text-[#EDE6D3]">Бабушка Варвара</p>
          <p className="flex items-center gap-1.5 text-[11px] text-[#7CCB8A]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#7CCB8A]" /> в сети
          </p>
        </div>
        <span className="ml-auto text-[11px] font-medium text-[#EDE6D3]/40">бот</span>
      </div>

      {/* Messages */}
      <div className="flex flex-1 flex-col justify-end gap-2.5 px-3.5 py-4">
        {chat.messages.map((m, i) =>
          m.from === "user" ? (
            <div key={i} className="flex justify-end">
              <div className="max-w-[80%] rounded-2xl rounded-br-md bg-gradient-to-br from-[#D4AF6E] to-[#F0C674] px-3.5 py-2 text-[13px] leading-snug text-[#0B0B1F]">
                {m.text}
                <span className="mt-0.5 flex items-center justify-end gap-0.5 text-[10px] text-[#0B0B1F]/60">
                  {m.time} <Check className="h-3 w-3" strokeWidth={3} />
                </span>
              </div>
            </div>
          ) : (
            <div key={i} className="flex justify-start">
              <div className="max-w-[85%] rounded-2xl rounded-bl-md border border-[#D4AF6E]/12 bg-[#1a1a40] px-3.5 py-2 text-[13px] leading-snug text-[#EDE6D3]/90">
                {m.text}
                <span className="mt-0.5 block text-right text-[10px] text-[#EDE6D3]/35">
                  {m.time}
                </span>
              </div>
            </div>
          )
        )}
      </div>

      {/* Fake input bar */}
      <div className="flex items-center gap-2 border-t border-[#D4AF6E]/12 bg-[#111133] px-3.5 py-2.5">
        <div className="flex-1 rounded-full bg-[#0b0b1f] px-3.5 py-2 text-xs text-[#EDE6D3]/35">
          Написать сообщение…
        </div>
        <span className="flex h-8 w-8 items-center justify-center rounded-full gold-gradient text-[#0B0B1F]">
          ➤
        </span>
      </div>
    </div>
  );
};
